import React, { useState, useEffect } from "react";
import { Select, MenuItem, Typography } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector,useDispatch } from "react-redux";
import { updateMeterDetails } from "../../../../../actions/home.action";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import { useMediaQuery } from "react-responsive";
import EAccount_SA_Switched_Warning from "../../../../e_account_sa_switch_warning/e_account-sa-switched-warning";


const useStyles = makeStyles((theme) => ({
  blueText: {
    backgroundColor: theme.palette.ePrimary?.base,
    borderRadius:"4px",
    padding:"6px 9px",
    border: "1px solid " +theme.palette.ePrimary?.base+ " !important",
    justifyContent: "flex-start",
    color:theme.palette.eWhite?.base,
    fontSize: "0.875rem",
  },
  mobilePadding:{
    padding:"6px 1px"
  }
}));

export const STYLED_SELECT = withStyles((theme) => ({
  root: {
    fontSize: "0.875rem",
    borderRadius: "4px",
    padding: "6px 9px",
    justifyContent: "flex-start",
    color: theme.palette.eWhite?.base,
    backgroundColor: theme.palette.ePrimary?.base + " !important",
},
select: {
    "&:focus": {
        borderRadius: "4px",
    },
    whiteSpace: "pre-line",
  },
  icon: {
    color: theme.palette.eWhite?.base,
  },
  
}))(Select);

export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    fontSize:"0.8rem",
    justifyContent:"flex-start",
    color: theme.palette.eRich?.base,
    whiteSpace:'inherit',
    textWrap: 'wrap',
    [theme.breakpoints.down("md")]:{
      textWrap: 'wrap'
     }
  }
}))(MenuItem);
export default function E_AccountDropdown() {
  const [connection, setConnection] = useState("");
  const [account,setAccount]=useState(null)
  const [showWarning,setShowWarning]=useState(false)
  const [openDialog,setOpenDialog]=useState(false)
  let dispatch=useDispatch();
  let classes=useStyles();
  const isMobile = useMediaQuery({ minWidth: 380 });
  let firstLogin=localStorage.getItem("firstLogin")
  let accountListData = useSelector(
    (store) =>
      store?.accountInformation?.personAcccountDetail?.personAccountList
  );
  let getFirstMeter = accountListData ? accountListData?.find(singleAcc => !singleAcc.isDisabled) : {};
  const [accountList,setAccountList]=useState(accountListData)
  useEffect(()=>{
    let accountList=[]
    if(accountListData){
      accountListData.filter((item)=>{
        if((item.accountSaList.length > 0)){
          accountList.push(item)
        }
      })
    }
  setAccountList(accountList)
  },[accountListData && firstLogin])
  let primaryIdentifier = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER
  );
  let accountId = useSelector(
    (store) => store?.meterDetails[primaryIdentifier]
  );

  useEffect(() => {
    if (accountId) {
      setConnection(accountId);
    }
  }, [accountId]);

  const updateDetails=()=>{
    setOpenDialog(false)
    setAccount(null)
    let selectedConnetionDetails; 
    let saId = connection
    if (accountList) {
      accountList.forEach((single, k) => {
        selectedConnetionDetails = single?.accountSaList?.forEach((item, i) => {
          if (Number(single?.[primaryIdentifier]) === Number(saId)) {
            if(i === 0) {
              localStorage.removeItem("enabled_state")
              dispatch(updateMeterDetails(single, item));
            }
          }
        });
      });
    }

  }

  const sameDetails=()=>{
    setOpenDialog(false)
    setConnection(account)
    setAccount(null)

  }
  
  const handleConnectionOnChange = (event) => {
    let selectedConnetionDetails; 
    let saId = event.target.value;
    localStorage.setItem("accountSelected",event.target.value);
    if (accountList) {
      accountList.forEach((single, k) => {
        selectedConnetionDetails = single?.accountSaList?.forEach((item, i) => {        
          if (Number(single?.[primaryIdentifier]) === Number(saId)) {
            if(i === 0) {
              let enabled_state_value=localStorage.getItem("enabled_state")
              if(enabled_state_value){
                setAccount(connection)
                setConnection(event.target.value);
                setShowWarning(true)
                setOpenDialog(true)
                return
              }
              setConnection(event.target.value);
              dispatch(updateMeterDetails(single, item));
            }
          }
        });
      });
    }
  };
  const ddlMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom"
    },
    transformOrigin: {
      vertical: "top"
    },
    getContentAnchorEl: null,
  };

  const NumberStringMenuItem = ({ number, string }) => {
    return (
       `${number} - ${string}`
    );
  };

  return (
    <>
    {showWarning ? (<EAccount_SA_Switched_Warning 
    heading="accountId"
    openDialog={openDialog}
    sameDetails={sameDetails}
    updateDetails={updateDetails}
    />):null}
      {accountList && accountList.length === 1 ? (
        <Typography className={`${classes.blueText} ${!isMobile ? classes.mobilePadding :''}`}>{accountList?.[0]?.[primaryIdentifier]}</Typography>
      ) : (
        <STYLED_SELECT
          value={account || connection}
          IconComponent={ExpandMoreSharpIcon}
          disableUnderline={true}
          MenuProps={ddlMenuProps}
          onChange={handleConnectionOnChange}
          renderValue={(value) => {
            return value;
          }}
        >
          {accountList !== undefined &&
            accountList.map((meter, k) => {
              let acc = `${meter?.[primaryIdentifier]}-${meter['mailingAddress']}`
              return (
                <STYLED_MENU_ITEM title={meter['mailingAddress']} key={k} value={meter?.[primaryIdentifier]}>
                  <NumberStringMenuItem number={meter?.[primaryIdentifier]} string={meter['mailingAddress']} />
                </STYLED_MENU_ITEM>
              );
            })}
        </STYLED_SELECT>
      )}
    </>
  );
}
